import { render } from "./enrols.vue?vue&type=template&id=68188e3a&scoped=true"
import script from "./enrols.vue?vue&type=script&lang=js"
export * from "./enrols.vue?vue&type=script&lang=js"

import "./enrols.vue?vue&type=style&index=0&id=68188e3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68188e3a"]])

export default __exports__